import * as React from 'react';
import { Component } from 'react';
import './LogIn.css';
import { RouteComponentProps } from 'react-router';
import { connect } from 'react-redux';
import { IUserInfo } from '../../models/IUserInfo';
import Footer from './Footer';
import { ImageContainer } from './ImageContainer';

function MapState(state) {
    return {
        UserInfo: state.Profile
    }
}

interface IProps extends RouteComponentProps<any> {
    UserInfo: IUserInfo | null
}

class RegisterFinalComponent extends Component<IProps, any> {
    constructor(props) {
        super(props);
    }

    public render() {
        return (
            <div className="login-component route-component">
                <div className="content-container">
                    <div className="content">
                        <div className="form-container">
                            <div className="form-container__wrapper">
                                <div className="kif-logo" />
                                <div className="header">
                                    <h3>Witamy!</h3>
                                    <span className="sub-header">Konto zostało pomyślnie utworzone! Zaloguj się aby mieć dostęp do serwisów KIF.</span>
                                </div>
                                <div className="submit-success-container">
                                    <div className="register-success" />
                                    <div className="form-buttons">
                                        <input type="submit" className="confirm-button-orange" value="Zaloguj się do serwisu" onClick={this.RedirectToLogIn} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ImageContainer />
                    </div>
                    <Footer />
                </div>
            </div>
        );
    }//end-of-render

    private RedirectToLogIn = (evt) => {
        this.props.history.push('/');
    }
}

export default connect(MapState)(RegisterFinalComponent);


// WEBPACK FOOTER //
// ./src/components/Login/RegisterFinal.tsx